/** A preference row never empties: the last remaining id cannot be removed. */
export const togglePreferenceId = (
  itemId: string,
  existingIds: string[],
): string[] => {
  if (existingIds.includes(itemId)) {
    return existingIds.length > 1
      ? existingIds.filter((id) => id !== itemId)
      : existingIds;
  }

  return [...existingIds, itemId];
};
